import React from 'react'
import { array, bool, func, string, node } from 'prop-types'
import { navigate } from 'gatsby'
import { connect } from 'react-redux'
import { css } from '@emotion/react'

import CartIcon from '@/assets/icons/cart.inline.svg'
import useHydrationContext from '@/hooks/useHydrationContext'
import { getCartProducts } from '@/store/selectors'
import mediaQueries from '@/layout/media-queries'

const cartWrapperCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
`

const badgeCss = (theme) => css`
  display: inline-block;
  box-sizing: border-box;
  padding: 0 3px;
  height: 18px;
  min-width: 18px;
  font-size: 10px;
  font-weight: ${theme.font.bold};
  line-height: 18px;
  text-align: center;
  border-radius: 18px;
  color: ${theme.colors.white};
  background-color: ${theme.colors.red500};
  position: absolute;
  right: -6px;
  bottom: 50%;
`

const iconCss = (theme) => css`
  &:hover {
    > path {
      fill: ${theme.colors.blue600};
    }
  }
`

const labelCss = (theme) => css`
  display: none;

  ${mediaQueries.xsmallScreen()} {
    margin-right: 10px;
    display: block;

    &:hover {
      color: ${theme.colors.blue600};
    }
  }
`

const Cart = ({
  products,
  showLabel,
  label = 'View Cart',
  handleClick = () => navigate('/cart/'),
  cartIcon = <CartIcon css={iconCss} />,
  className,
}) => {
  const hydrated = useHydrationContext()

  return (
    <div
      data-test="cart-icon"
      css={cartWrapperCss}
      onClick={(e) => {
        e.preventDefault()

        if (handleClick) {
          handleClick()
        }
      }}
      className={className}
    >
      {showLabel && (
        <div className="cart-label" css={labelCss}>
          {label}
        </div>
      )}

      {hydrated && products.length > 0 && (
        <span css={badgeCss} data-test="cart-icon-badge">
          {products.length}
        </span>
      )}

      {cartIcon}
    </div>
  )
}

Cart.propTypes = {
  products: array,
  showLabel: bool,
  handleClick: func,
  label: string,
  cartIcon: node,
  className: string,
}

const mapStateToProps = (state) => {
  return {
    products: getCartProducts(state),
  }
}

export default connect(mapStateToProps)(Cart)
